import { fireEvent } from '#src/common/lib/events'
import { ADD_TO_BAG } from '#src/common/lib/events/topics'
import { getClickEventAddToBagGiftingPayload } from '../utils/payloads'

export const clickEventAddToBagGifting = () => {
  fireEvent(ADD_TO_BAG, getClickEventAddToBagGiftingPayload())
}
